import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@mui/material';
import ShowMoreTextWrapper from 'app/pages/loanApplication/LoanTabLayout/ShowMoreTextWrapper';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getContactInfoStringByEmail, getRecipientsWithNames } from '../../../Activities.utils';
import HighlightText from '../../../HighlightText';

const defaultArray = [];

const EmailMeta = ({
  recipientsString = '',
  contacts = defaultArray,
  from = '',
  cc = defaultArray,
  bcc = defaultArray,
}) => {
  const highlightText = useSelector(getDebouncedSearchValue);

  const senderString = useMemo(() => getContactInfoStringByEmail(contacts, from), [contacts, from]);

  const ccString = useMemo(
    () => getRecipientsWithNames({ contacts, receivers: cc }),
    [contacts, cc],
  );

  const bccString = useMemo(
    () => getRecipientsWithNames({ contacts, receivers: bcc }),
    [contacts, bcc],
  );

  const contactsFields = [
    [recipientsString, 'To'],
    [ccString, 'CC'],
    [bccString, 'BCC'],
    [senderString, 'From'],
  ];

  return (
    <div className="table table-auto grow">
      {contactsFields.map(
        ([value, label], index) =>
          !!value && (
            <div className="table-row h-36" key={index}>
              <Typography
                className={clsx(!!index && 'border-t', 'table-cell p-2 pl-0')}
                variant="regular16"
              >
                {label}:
              </Typography>

              <Typography
                className={clsx(!!index && 'border-t', 'table-cell w-full p-2')}
                color="textSecondary"
                variant="regular14"
              >
                <ShowMoreTextWrapper
                  buttonClassName="self-center leading-3"
                  linesToTruncate={1}
                  showLessText="less"
                  showMoreText="more"
                  text={<HighlightText highlight={highlightText} text={value} />}
                  wrapperClassName="flex"
                />
              </Typography>
            </div>
          ),
      )}
    </div>
  );
};

EmailMeta.propTypes = {
  recipientsString: PropTypes.string,
  contacts: PropTypes.arrayOf(PropTypes.object),
  from: PropTypes.string,
  cc: PropTypes.arrayOf(PropTypes.string),
  bcc: PropTypes.arrayOf(PropTypes.string),
};

export default memo(EmailMeta);
